import { IconType } from 'react-icons/lib';

const ReopenJobIcon: React.FC<{ color?: string; height?: number; width?: number }> = ({
  color,
  height = 24,
  width = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.5" cy="16" r="16" fill="#00B4D8" />
    <g clipPath="url(#clip0_1003_26765)">
      <path
        d="M24.5797 7.76299C23.8098 6.99307 22.5652 6.99307 21.7953 7.76299L20.7371 8.81768L24.1789 12.2595L25.2371 11.2013C26.007 10.4313 26.007 9.18682 25.2371 8.41689L24.5797 7.76299ZM14.0609 15.4974C13.8465 15.7118 13.6812 15.9755 13.5863 16.2673L12.5457 19.3892C12.4437 19.6915 12.5246 20.0255 12.7496 20.254C12.9746 20.4825 13.3086 20.5599 13.6145 20.4579L16.7363 19.4173C17.0246 19.3224 17.2883 19.1571 17.5062 18.9427L23.3879 13.0575L19.9426 9.61221L14.0609 15.4974ZM11.375 9.2501C9.51172 9.2501 8 10.7618 8 12.6251V21.6251C8 23.4884 9.51172 25.0001 11.375 25.0001H20.375C22.2383 25.0001 23.75 23.4884 23.75 21.6251V18.2501C23.75 17.6278 23.2473 17.1251 22.625 17.1251C22.0027 17.1251 21.5 17.6278 21.5 18.2501V21.6251C21.5 22.2474 20.9973 22.7501 20.375 22.7501H11.375C10.7527 22.7501 10.25 22.2474 10.25 21.6251V12.6251C10.25 12.0028 10.7527 11.5001 11.375 11.5001H14.75C15.3723 11.5001 15.875 10.9974 15.875 10.3751C15.875 9.75283 15.3723 9.2501 14.75 9.2501H11.375Z"
        fill={color ?? 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1003_26765">
        <rect width="18" height="18" fill="white" transform="translate(8 7)" />
      </clipPath>
    </defs>
  </svg>
);

const ReopenedJobIcon: IconType = () => <ReopenJobIcon color="currentColor" />;

export default ReopenedJobIcon;
export { ReopenJobIcon };
